/** @module csi/widget/CheckboxDialogAction */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/Tooltip",
	"dojo/text!./CheckboxDialogAction.html",
	"csi/widget/CheckBox"

], function(declare,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,Tooltip,template){

	return declare([_WidgetBase,_TemplatedMixin,_WidgetsInTemplateMixin], {
		
		templateString: template,
		
		/* @property {string} label - label for the checkbox */
		label:"",
		_setLabelAttr: {node:"labelNode", type:"innerText"},

		/* @property {string} tooltip - tooltip for the checkbox */
		tooltip: "",

		/* @property {boolean} value - initial value for the checkbox */
		value: false,
		
		/* @property {boolean} disabled - inital status for the checkbox */
		disabled: true,
	   
		startup: function() {
			// attach tooltip to the checkbox
			new Tooltip ({
				connectId: this.domNode,
				position: ["below-centered"],
				label: this.tooltip
			});
		},

		_onChange: function(value) {
			this._set("value", value);
			this.onChange(value);
		},

		/**
		 * Callback for when checkbox value changes
		 * @param {boolean} value
		 */
		onChange: function(value) {
		},

		/**
		 * Set the value of the checkbox
		 * @param {any} value
		 */
		_setValueAttr: function(value) {
		   this.checkboxNode.set("value", !!value);
		},

		/**
		 * Disable the checkbox
		 * @param {boolean} bDisabled
		 */
		_setDisabledAttr: function(bDisabled) {
			this._set("disabled", bDisabled);
			this.checkboxNode.set("disabled", bDisabled);
		}

	});
});